<script lang="ts" setup>
const districtSlugsWithoutQuestionableInfo = ['kreis-harburg']

definePageMeta({
  layout: 'default',
})

const nuxtApp = useNuxtApp()

const citySlug = useRoute().params.city

const { data } = await useAsyncData(`city-page-${citySlug}`, async () => {
  const { city, offices, district } = await $fetch(`/api/city/${citySlug}`)

  const closeCities = await $fetch(`/api/get-close-cities/${citySlug}`)

  const stine = await nuxtApp.$trpc.public.stineStatusByKingCitySlug
    .query({ cityName: city.slug })
    .catch(() => false)

  const showQuestionableInfo = !districtSlugsWithoutQuestionableInfo.includes(district.slug as string)

  return {
    city,
    offices,
    closeCities,
    stine,
    district,
    showQuestionableInfo
  }
}, {
  getCachedData (key, nuxtApp) {
    return nuxtApp.payload.data[key]
  }
})

const title = `${data.value?.city.name}: Auto online abmelden mit i-Kfz`

const description = `${data.value?.district.name}: offizielle Bescheinigung sofort als PDF verfügbar in 3 Minuten. Bequem von zu Hause aus mit dem Smartphone oder PC.`

useSeoMeta({
  title,
  description
})

provide('city', data.value?.city)
provide('offices', data.value?.offices)
provide('showQuestionableInfo', data.value?.showQuestionableInfo)
</script>

<template lang="pug">
#city-page.bg-white
  LandingPage(:locality="data?.city.name", :stine="data?.stine")

  section.py-24.px-3.bg-slate-700
    .container.mx-auto
      OfficesInformation(
        :offices="data?.offices"
        :locationName="data?.city.name"
      )

LayoutFooter(
  :closeCities="data?.closeCities"
  :district="data?.district"
)

</template>

<style lang="sass">
</style>
